import React from 'react';
import { useTheme } from '@mui/material/styles';

const LanternalLogo = ({ size = 35, environment, ...props }) => {
  const theme = useTheme();
  const logoSrc = '/static/console-logo.svg';

  // Invert colors for dark mode: SVG is black by default, so invert it to white in dark mode
  const filter = theme.palette.mode === 'dark' ? 'invert(1)' : 'none';

  return (
    <img
      alt="Console Logo"
      src={logoSrc}
      style={{
        width: size,
        height: size,
        filter,
      }}
      {...props}
    />
  );
};

export default LanternalLogo;
